import { ModuleFE_SandboxFHIR } from '../../modules/ModuleFE_SandboxFHIR/index.js';
import { Base_RequestHistory } from '../../Page_BaseSandbox/Base_RequestHistory/index.js';
export class FHIRSandboxRequestHistory extends Base_RequestHistory {
    getHistory() {
        return ModuleFE_SandboxFHIR.getHistory();
    }
    clearHistory() {
        ModuleFE_SandboxFHIR.clearHistory();
    }
    convertHistoryMessageToPrint(historyMessage) {
        return historyMessage.content;
    }
}
//# sourceMappingURL=FHIRSandboxRequestHistory.js.map